// extracted by mini-css-extract-plugin
module.exports = {"container":"_6d98004b","title":"_c397420c","divider":"_3ea599cd","body":"_fa8e79c"};